export default __webpack_public_path__ + "static/media/logo2.65cd4aa4.svg";